export default "<video #videoEl autoplay loop playsinline>\n  <source [src]=\"videoUrl\" type='video/mp4'>\n</video>\n";